module.exports = __webpack_public_path__ + "media/get-serious-leads.cc3950e0.svg";